/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ScheduledChangeDetail } from './scheduledChangeDetail';

export type GenericApiResponseScheduledChangeDetailData = ScheduledChangeDetail | null;
